import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "fp_cookie_notice_acknowledged_v1";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Aviso de cookies"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60] rounded-lg border bg-background shadow-lg p-4 md:p-5"
    >
      <div className="flex items-start gap-3">
        <div className="shrink-0 rounded-full bg-[hsl(152,40%,53%)]/10 p-2">
          <Cookie className="h-5 w-5 text-[hsl(152,40%,40%)]" />
        </div>
        <div className="flex-1 space-y-2">
          <h2 className="text-sm font-semibold">Uso de cookies</h2>
          <p className="text-xs text-muted-foreground leading-relaxed">
            Esta aplicación utiliza únicamente <strong>cookies técnicas</strong> estrictamente
            necesarias para mantener tu sesión iniciada. No utilizamos cookies de análisis,
            publicidad ni de terceros con fines de seguimiento. Más información en nuestra{" "}
            <Link to="/privacidad" className="text-[hsl(152,40%,40%)] underline hover:no-underline">
              política de privacidad
            </Link>
            .
          </p>
          <div className="flex items-center justify-end gap-2 pt-1">
            <Button
              size="sm"
              onClick={accept}
              className="bg-[hsl(152,40%,53%)] hover:bg-[hsl(152,40%,45%)] text-white h-8"
            >
              Entendido
            </Button>
          </div>
        </div>
        <button
          onClick={accept}
          aria-label="Cerrar aviso"
          className="shrink-0 rounded-sm opacity-60 hover:opacity-100 transition-opacity"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
